import DelayedFadeIn from "../../DelayedFadeIn";
import React from "react";

interface GreetingPillProps {
  currentGreeting: string;
}

const GreetingPill: React.FC<GreetingPillProps> = ({ currentGreeting }) => {

  return (
    <DelayedFadeIn delay={300}>
      <div id="greeting-pill" className="mb-4 sm:mb-6 flex justify-center w-full">
        <span className="inline-block bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 px-4 py-2 rounded-full text-sm font-medium border border-blue-200 dark:border-blue-800">
          {currentGreeting || 'Welcome to CadenceAI! 🚀'}
        </span>
      </div>
    </DelayedFadeIn>
  );
};

export default GreetingPill;